import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from "reactstrap"
import FilterSku from "./filters/FilterSku"
import FilterName from "./filters/FilterName"
import FilterStatus from "./filters/FilterStatus"
import FilterProcedure from "./filters/FilterProcedure"
import FilterPartner from "./filters/FilterPartner"
import FilterMex from './filters/FilterMex'
import { filterCutLaze } from '../helpers/skuFilter'
import { FormGroup, Input, Label } from 'reactstrap'
import { Select } from 'antd'

class SkuFilters extends Component {

    onChangeCutLaze = (e) => {
        const { name, value } = e.target
        const { onChangeFilter } = this.props

        if (typeof onChangeFilter === 'function') {
            const booleanValue = value === '' ? '' : value === 'true'
            onChangeFilter(name, booleanValue)
        }
    }

    render() {
        const { filters, onChangeFilter, onChangeFilterName, listPartner, onChangeFilters, listProductionProcess, list_catalog = [], listMaterial = [] } = this.props || {}

        const partnerOptions = listPartner.filter(i => i.name === "QUANG MINH" || i.name === "TOÀN CẦU" || i.name === "BINH MINH").map(i => ({
            label: i.name,
            value: i._id,
        }))

        const processOptions = listProductionProcess.map(i => ({ label: i.name, value: i._id }))
        const commitmentTimeFastProduction = [
            { label: 'All', value: 'all' },
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
        ]

        const catalogOptions = !!list_catalog && Array.isArray(list_catalog) ? list_catalog.map(i => ({ label: i.name, value: i._id })) : []

        // SKU lưu NVL chính dạng chuỗi `${code} - ${name}` (trường materials), không lưu _id
        const materialOptions = Array.isArray(listMaterial)
            ? [...new Set(listMaterial.filter(i => i.name).map(i => !!i.code ? `${i.code} - ${i.name}` : i.name))].map(label => ({ label, value: label }))
            : []

        return (
            <div className="SkuFilters pt-3 pl-3 pr-3 mb-3">
                <Row form>
                    <Col md={2} style={{ minWidth: '287px' }}>
                        <FilterName name={filters.name} onChangeFilter={onChangeFilterName} />
                    </Col>
                    <Col md={3} style={{ minWidth: '424px' }}>
                        <FilterSku sku={filters.sku} onChangeFilter={onChangeFilter} onChangeFilters={onChangeFilters} filters={filters} />
                    </Col>
                    <Col md={1} style={{ minWidth: '120px' }}>
                        <FilterStatus status={filters.is_active} onChangeFilter={onChangeFilter} />
                    </Col>
                    <Col md={1} style={{ minWidth: '120px' }}>
                        <FilterProcedure procedure={filters.procedure} onChangeFilter={onChangeFilter} />
                    </Col>
                    <Col md={1} style={{ minWidth: '120px' }}>
                        <FilterMex procedure={filters.partner} onChangeFilter={onChangeFilter} selectOptions={partnerOptions} />
                    </Col>
                    <Col md={1} style={{ minWidth: '120px' }}>
                        <div className="FilterCutLaze">
                            <FormGroup>
                                <Label className='font-weight-bold'>Cắt Laze</Label>
                                <Input type='select' name='is_cut_laze' onChange={this.onChangeCutLaze}>
                                    {
                                        filterCutLaze.map(item => {
                                            return <option key={item.value} value={item.value}>{item.name}</option>
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </div>
                    </Col>
                    <Col md={1} style={{ minWidth: '210px' }}>
                        <FilterPartner partner={filters.partner} onChangeFilter={onChangeFilter} selectOptions={partnerOptions} />
                    </Col>
                    <Col md={2} style={{ minWidth: '120px' }}>
                        <div className="FilterProcess">
                            <div className="Select">
                                <Label style={{ whiteSpace: "nowrap" }}>Quy trình sản xuất</Label>
                                <Select
                                    options={processOptions}
                                    style={{ width: '100%' }}
                                    placeholder='Chọn quy trình sản xuất'
                                    showSearch
                                    value={filters.production_process || []}
                                    onChange={(value) => onChangeFilter('production_process', value)}
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={2}>
                        <div className="FilterProcess">
                            <div className="Select form-group">
                                <Label style={{ whiteSpace: "nowrap" }}>Thời gian sản xuất nhanh</Label>
                                <Select
                                    options={commitmentTimeFastProduction}
                                    style={{ width: '100%' }}
                                    placeholder='Thời gian sản xuất nhanh'
                                    showSearch
                                    value={filters.has_commitment_time_fast_production || []}
                                    onChange={(value) => onChangeFilter('has_commitment_time_fast_production', value)}
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={2}>
                        <div className="FilterProcess">
                            <div className="Select form-group">
                                <Label style={{ whiteSpace: "nowrap" }}>Danh mục sản phẩm</Label>
                                <Select
                                    options={catalogOptions}
                                    style={{ width: '100%' }}
                                    placeholder='Danh mục sản phẩm'
                                    showSearch
                                    value={filters.catalog || []}
                                    onChange={(value) => onChangeFilter('catalog', value)}
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} style={{ minWidth: '287px' }}>
                        <div className="FilterProcess">
                            <div className="Select form-group">
                                <Label style={{ whiteSpace: "nowrap" }}>Nguyên vật liệu</Label>
                                <Select
                                    mode="multiple"
                                    options={materialOptions}
                                    style={{ width: '100%' }}
                                    placeholder='Chọn nguyên vật liệu'
                                    showSearch
                                    value={filters.materials || []}
                                    onChange={(value) => onChangeFilter('materials', value)}
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

SkuFilters.propTypes = {
    filters: PropTypes.object,
    onChangeFilter: PropTypes.func,
    onChangeFilterName: PropTypes.func
}

export default SkuFilters